import { Box, Button, Checkbox, FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material'
import { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import { DescargableI } from '../../../models/descargables'
import CustomInputFile from '../../Custom/InputFile'
import useDescargableAdd from './useDescargableAdd'
import { CATEGORIAS_DESCARGABLES } from '../../../constants/Select'


interface Props {
  descargable?: DescargableI,
}

const DescargableAdd: FC<Props> = ({ descargable }) => {

  const { 
    onChange, 
    handleSubmit, 
    formData, 
    setFormData,
    setImages 
  } = useDescargableAdd({descargable})
  const navigate = useNavigate()

  return (
    <>

      <Box component='form' onSubmit={handleSubmit} style={{
        display: "flex",
        flexDirection: "column",
        gap: 10,
        background: '#fff',
        padding: '4%',
        paddingBottom: '10%'

      }}>

        <h1>Descargables</h1>
       

        <TextField label="Titulo" variant='outlined' value={formData.titulo} name="titulo" onChange={onChange} style={{ background: '#fff' }} required />

        <TextField label="Descripcion Breve" variant='outlined' value={formData.descripcion_breve} name="descripcion_breve" onChange={onChange} style={{ background: '#fff' }} required />

        <FormControl>
          <InputLabel >Categorias</InputLabel>
          <Select label="Orden" name="categorias" onChange={onChange} value={formData.categorias}>
            {CATEGORIAS_DESCARGABLES.map((categoria: string, index: number) => (
              <MenuItem key={index} value={categoria}>{categoria}</MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl>
          <InputLabel>Restringido</InputLabel>

          <Checkbox checked={formData.restringido} onChange={() => {
              setFormData(prev=>({
                ...prev,
                restringido: !prev.restringido
              }))
            }} />
        </FormControl>
      
        
        <CustomInputFile label='Imagen thumb (848 x 566px)' onChange={e => {
          setImages(prev => ({
            ...prev,
            imgThumb: e.target.files ? e.target.files[0] : undefined
          }))
        }} img={formData.path_img_thumb} />

        <CustomInputFile type='pdf' label='PDF' onChange={e => {
          setImages(prev => ({
            ...prev,
            uploadPDF: e.target.files ? e.target.files[0] : undefined
          }))
        }} img={formData.path_descargar_pdf} />

        <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end',}}>
          <Button color="success" variant="contained" type='submit' style={{ background: '#000',
            fontFamily: 'WorkSans',
            fontWeight: '500',
            fontSize: '14px',
            lineHeight: '16px',
            textAlign: 'center',
            textTransform: 'uppercase',
            color: '#FFF',
            padding: '17px 62px',
            border: 'none',
            cursor: 'pointer', }} >Guardar</Button>
          <Button color="error" variant="contained" onClick={() => {
            navigate("/descargable")
          }} style={{background: '#D8D8D8',
          fontFamily: 'WorkSans',
          fontWeight: '500',
          fontSize: '14px',
          lineHeight: '16px',
          textAlign: 'center',
          textTransform: 'uppercase',
          color: '#5E5E5E',
          padding: '17px 62px',
          border: 'none',
          marginLeft: '20px',
          cursor: 'pointer',}}>Cancelar</Button>
        </div>

      </Box>
    </>



  )
}

export default DescargableAdd